<template>
  <a-form-model
    v-if="project"
    class="part form project"
    ref="projectForm"
    :model="project"
    :rules="rules"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
  >
    <!-- {{ project }} -->
    <a-row type="flex">
      <!-- column left -->
      <a-col :span="24" :md="12">
        <!-- Customer  -->

        <a-form-model-item label="Customer" prop="customer">
          <CustomerChanger :customer="project.customer" class="ant-input ant-input-lg" />
        </a-form-model-item>

        <!-- Property -->
        <a-form-model-item label="Property" prop="property">
          <a-select v-model="project.property" default-value="house" style="width: 100%" :size="size">
            <a-select-option v-for="option in options_['PROPERTY_TYPES']" :key="option.key" :value="option.key">
              {{ option.value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <!-- Services -->

        <a-form-model-item label="Services" prop="services">
          <a-select
            v-model="project.services"
            default-value="interior_renovation"
            mode="multiple"
            style="width: 100%"
            :size="size"
          >
            <a-select-option v-for="option in options_['SERVICE_TYPES']" :key="option.key" :value="option.key">
              {{ option.locales[locale] }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <!-- Start/End Date -->
        <a-form-model-item label="Start/End Date" prop="start_date">
          <a-input-group compact>
            <a-date-picker v-model="project.start_date" :size="size" style="width: 50%" />
            <a-date-picker v-model="project.end_date" :size="size" style="width: 50%" />
          </a-input-group>
        </a-form-model-item>

        <!-- Team Assignment -->
        <a-form-model-item label="Team">
          <a-input-group>
            <a-select v-model="project.team" default-value="null" style="width: 100%" :size="size">
              <a-select-option v-for="team in teams" :key="team._id" :value="team._id">
                【 {{ team.alias }} 】 {{ team.name }}
              </a-select-option>
            </a-select>
          </a-input-group>
        </a-form-model-item>

        <!-- Discount -->
        <a-form-model-item label="Discount" prop="discount">
          <a-input-number
            v-model="project.discount"
            :default-value="0"
            :min="0"
            :max="100"
            :formatter="(value) => `${value} %`"
            :parser="(value) => value.replace('%', '')"
            :size="size"
          />
        </a-form-model-item>

        <!-- Address Search  -->
        <a-form-model-item label="Search Address">
          <PlaceAutocompleteInput
            id="address"
            class="ant-input ant-input-lg"
            placeholder="Type to search address"
            @placechanged="onPlaceChanged"
          />
        </a-form-model-item>

        <!-- Address -->
        <a-form-model-item label="Full Address" prop="raw_address">
          <a-input v-model="project.raw_address" :size="size" />
        </a-form-model-item>

        <!-- Location -->
        <a-form-model-item label="Location" prop="location">
          <a-input v-model="project.location" :size="size" />
        </a-form-model-item>

        <!-- Note -->
        <a-form-model-item label="Note" prop="note">
          <a-input v-model="project.note" type="textarea" :rows="4" :size="size" />
        </a-form-model-item>
      </a-col>

      <!-- column right -->
      <a-col :span="24" :md="12">
        <!-- Specialist -->
        <a-form-model-item label="Specialist">
          <a-input-group>
            <a-select v-model="project.specialist" default-value="null" style="width: 100%" :size="size">
              <a-select-option v-for="staff in staffs" :key="staff._id" :value="staff._id">
                {{ staff.display_name }}
              </a-select-option>
            </a-select>
          </a-input-group>
        </a-form-model-item>

        <!-- Source -->
        <a-form-model-item label="Source" prop="source">
          <a-input-group>
            <a-select v-model="project.source" default-value="Unknown" style="width: 100%" :size="size">
              <a-select-option v-for="option in options_['GENERAL_SOURCES']" :key="option.key" :value="option.key">
                {{ option.value }}
              </a-select-option>
            </a-select>
          </a-input-group>
        </a-form-model-item>

        <!-- Referer -->
        <a-form-model-item label="Referer" prop="referer">
          <a-input v-model="project.referer" :size="size" />
        </a-form-model-item>

        <!-- Description -->
        <a-form-model-item label="Description" prop="description">
          <a-input v-model="project.description" type="textarea" :rows="20" :size="size" />
        </a-form-model-item>
      </a-col>
    </a-row>

    <!-- Actions -->
    <a-form-model-item>
      <a-button type="primary" @click="onSubmit"> Create </a-button>
      <a-button class="ml-2" @click="onClose"> Cancel </a-button>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { CustomerChanger } from '@/components/reno/changers'
import { PlaceAutocompleteInput } from '@/components/reno/inputs'
import * as staffsService from '@/services/system/staffs'
import * as teamsService from '@/services/pm/teams'

export default {
  name: 'project-form',
  components: {
    CustomerChanger,
    PlaceAutocompleteInput,
  },
  props: ['visible'],
  data() {
    return {
      staffs: [],
      teams: [],
      size: 'large',
      labelCol: { xs: 24, sm: 5 },
      wrapperCol: { xs: 24, sm: 19 },
      rules: {
        customer: [{ validator: this.customerValidator, trigger: 'blur' }],
        property: [{ required: true, message: 'Please select property', trigger: 'blur' }],
        services: [{ required: true, message: 'Please select services', trigger: 'blur' }],
        description: [{ required: true, message: 'Please write project description', trigger: 'blur' }],
      },
    }
  },
  watch: {
    visible(newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.$store.commit('pm/SET_NEW_PROJECT', { customer: this.project.customer || null })
        this.project = this.$store.getters['pm/new_project']
      }
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale ? (this.$i18n.locale === 'zh-CN' ? 'zh' : 'en') : 'en'
    },
    project: {
      get() {
        return this.$store.state.pm.new_project
      },
      set(project) {
        this.$store.commit('pm/SET_NEW_PROJECT', project)
      },
    },
  },
  methods: {
    customerValidator(rule, value, callback) {
      if (!this.project.customer) {
        callback(new Error('Please select the customer'))
      } else {
        if (!this.rules.customer) {
          this.$refs.ruleForm.validateField('customer')
        }
        callback()
      }
    },
    onPlaceChanged(place) {
      if (place) {
        // console.log(place)
        if (place.formatted_address) {
          this.project.raw_address = place.formatted_address
        }
        if (place.locality && place.administrative_area_level_1) {
          this.project.location = `${place.locality},${place.administrative_area_level_1}`
        }
        this.project = Object.assign({}, this.project)
      }
    },
    onSubmit() {
      this.$refs.projectForm.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.project)
        } else {
          console.log('project error submit!!')
          return false
        }
      })
    },
    onRest() {
      this.$refs.projectForm.resetFields()
    },
    onClose() {
      this.$store.dispatch('pm/close', 'CREATE_PROJECT')
      this.$emit('close', true)
    },
  },
  async created() {
    if (this.customer && this.customer._id) this.project.customer = this.customer._id
    this.staffs = await staffsService.fetchAllStaffs()
    this.teams = await teamsService.fetchTeams()
  },
  mounted() {
    this.project = this.$store.getters['pm/new_project']
  },
}
</script>

<style lang="scss" scoped>
.form.project {
  .customr-name {
    display: flex;
    span {
      font-size: 1.2rem;
    }
    .lastname {
      margin-right: 6px;
    }
  }
}
</style>
